const intervals = [
    {
        text: "interval.every_minute",
        value: 60
    },
    {
        text: "interval.every_five_minutes",
        value: 300
    },
    {
        text: "interval.every_ten_minutes",
        value: 600
    },
    {
        text: "interval.every_fifteen_minutes",
        value: 900
    },
    {
        text: "interval.every_half_hour",
        value: 1800
    },
    {
        text: "interval.every_hour",
        value: 3600
    },
    {
        text: "interval.every_second_hour",
        value: 7200
    },
    {
        text: "interval.every_third_hour",
        value: 10800
    },
    {
        text: "interval.every_fourth_hour",
        value: 14400
    },
    {
        text: "interval.every_fifth_hour",
        value: 18000
    },
    {
        text: "interval.every_sixth_hour",
        value: 21600
    },
    {
        text: "interval.every_day",
        value: 86400
    },
    {
        text: "interval.every_second_day",
        value: 172800
    },
    {
        text: "interval.every_third_day",
        value: 259200
    },
    {
        text: "interval.every_fourth_day",
        value: 345600
    },
    {
        text: "interval.every_fifth_day",
        value: 432000
    },
    {
        text: "interval.every_sixth_day",
        value: 518400
    },
    {
        text: "interval.every_week",
        value: 604800
    },
    {
        text: "interval.every_second_week",
        value: 1209600
    },
    {
        text: "interval.every_third_week",
        value: 1814400
    },
    {
        text: "interval.every_fourth_week",
        value: 2419200
    },
    {
        text: "interval.every_fifth_week",
        value: 3024000
    },
    {
        text: "interval.every_month",
        value: 2592000
    },
    {
        text: "interval.every_second_month",
        value: 5184000
    }, 
    {
        text: "interval.every_third_month",
        value: 7776000    
    },
    {
        text: "interval.every_fourth_month",
        value: 10368000
    },
    {
        text: "interval.every_fifth_month",
        value: 12960000
    },
    {
        text: "interval.every_half_year",
        value: 15778800
    },
    {
        text: "interval.every_year",
        value: 31557600
    },
    {
        text: "interval.every_second_year",
        value: 63115200
    }
];

export default intervals;